module.exports = __webpack_public_path__ + "img/ai1.f9a8c830.png";